// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.of-comparatif-container {
  padding: 2rem;
}

.presta-comparaison-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}

.presta-col {
  background-color: #fffdfc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 2rem;
  position: relative;
}

.presta-col.disabled {
  opacity: 0.5;
  /* pointer-events: none; */
  position: relative;
}

.presta-header {
  background-color: rgba(5, 3, 3, 0.5);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 2rem;
  text-align: center;
}

.presta-header h3 {
  font-size: 1.8rem;
  color: #2c3948;
  margin: 0 0 0.5rem 0;
}

.presta-header span {
  font-size: 1.4rem;
  color: #6b7280;
}

.articles-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.articles-table th,
.articles-table td {
  padding: 0.8rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.articles-table th {
  background-color: #d7d9d940;
  font-weight: 600;
  color: #2c3948;
}

/* .articles-table th:last-child,
.articles-table td:last-child {
  text-align: right;
} */

.sections-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-item {
  border-radius: 12px;
  background-color: white;
}

.section-header td {
  background-color: rgba(194, 194, 194, 0.5);
  color: #2c3948;
  text-align: center;
  font-weight: 600;
}

.section-body:last-child td {
  border-bottom: none !important;
}

.section-body td {
  text-align: right;
}

.article-numero {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.info-icon {
  width: 16px;
  height: 16px;
  opacity: 0.6;
  cursor: help;
}

.question-icon {
  width: 16px;
  height: 16px;
  opacity: 0.6;
  cursor: help;
}

.total-row {
  font-weight: 700;
  font-size: 1.6rem;
  text-align: right;
  padding: 1rem;
  background-color: rgba(215, 217, 217, 0.2);
  border-radius: 4px;
  margin-bottom: 2rem;
}

.note-financiere {
  text-align: center;
  padding: 1.5rem;
  background-color: rgba(218, 112, 39, 0.15);
  border-radius: 8px;
}

.note-financiere h4 {
  font-size: 1.6rem;
  color: #2c3948;
  margin: 0 0 1rem 0;
}

.note-value {
  font-size: 2.4rem;
  font-weight: 700;
  color: #2c3948;
}

/* .loading,
.error {
  text-align: center;
  padding: 2rem;
  font-size: 1.6rem;
  color: #6b7280;
}

.error {
  color: #ef4444;
} */

.no-data {
  text-align: center;
  padding: 4rem 2rem;
  color: #6b7280;
  font-size: 1.6rem;
}

.table-section-header {
  background-color: #d7d9d940;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  color: #2c3948;
  font-weight: 700;
  font-size: 1.3rem;
}

.presta-col.accepted {
  border: 3px solid #da7027;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
}

/* .best-note-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #da7027;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
  width: 192px;
  text-align: center;
} */
`, "",{"version":3,"sources":["webpack://./src/composants/AnalyseOffreFinanciere/AnalyseOffreFinanciere.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;;;;;;;;;;;;;;GAcG","sourcesContent":[".of-comparatif-container {\n  padding: 2rem;\n}\n\n.presta-comparaison-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 2rem;\n}\n\n.presta-col {\n  background-color: #fffdfc;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 2rem;\n  position: relative;\n}\n\n.presta-col.disabled {\n  opacity: 0.5;\n  /* pointer-events: none; */\n  position: relative;\n}\n\n.presta-header {\n  background-color: rgba(5, 3, 3, 0.5);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.presta-header h3 {\n  font-size: 1.8rem;\n  color: #2c3948;\n  margin: 0 0 0.5rem 0;\n}\n\n.presta-header span {\n  font-size: 1.4rem;\n  color: #6b7280;\n}\n\n.articles-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 1rem;\n}\n\n.articles-table th,\n.articles-table td {\n  padding: 0.8rem;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.articles-table th {\n  background-color: #d7d9d940;\n  font-weight: 600;\n  color: #2c3948;\n}\n\n/* .articles-table th:last-child,\n.articles-table td:last-child {\n  text-align: right;\n} */\n\n.sections-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.section-item {\n  border-radius: 12px;\n  background-color: white;\n}\n\n.section-header td {\n  background-color: rgba(194, 194, 194, 0.5);\n  color: #2c3948;\n  text-align: center;\n  font-weight: 600;\n}\n\n.section-body:last-child td {\n  border-bottom: none !important;\n}\n\n.section-body td {\n  text-align: right;\n}\n\n.article-numero {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.info-icon {\n  width: 16px;\n  height: 16px;\n  opacity: 0.6;\n  cursor: help;\n}\n\n.question-icon {\n  width: 16px;\n  height: 16px;\n  opacity: 0.6;\n  cursor: help;\n}\n\n.total-row {\n  font-weight: 700;\n  font-size: 1.6rem;\n  text-align: right;\n  padding: 1rem;\n  background-color: rgba(215, 217, 217, 0.2);\n  border-radius: 4px;\n  margin-bottom: 2rem;\n}\n\n.note-financiere {\n  text-align: center;\n  padding: 1.5rem;\n  background-color: rgba(218, 112, 39, 0.15);\n  border-radius: 8px;\n}\n\n.note-financiere h4 {\n  font-size: 1.6rem;\n  color: #2c3948;\n  margin: 0 0 1rem 0;\n}\n\n.note-value {\n  font-size: 2.4rem;\n  font-weight: 700;\n  color: #2c3948;\n}\n\n/* .loading,\n.error {\n  text-align: center;\n  padding: 2rem;\n  font-size: 1.6rem;\n  color: #6b7280;\n}\n\n.error {\n  color: #ef4444;\n} */\n\n.no-data {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: #6b7280;\n  font-size: 1.6rem;\n}\n\n.table-section-header {\n  background-color: #d7d9d940;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  color: #2c3948;\n  font-weight: 700;\n  font-size: 1.3rem;\n}\n\n.presta-col.accepted {\n  border: 3px solid #da7027;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);\n}\n\n/* .best-note-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #da7027;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-weight: 600;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 2;\n  width: 192px;\n  text-align: center;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
